import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "../../pages/Shipping-Policy/Shipping-Policy.css";
import "./PolicyPage.css";

const DIVIDER =
  "https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg";

// Shared layout for the legal pages (Website Disclaimer, Consultation Policy).
// Reuses the Shipping/Refund policy look: gold-badge hero card, then headed
// sections. `data` is { badge, pageTitle, heading, tagline, intro, highlights,
// sections: [{ title, paragraphs, bullets?, after? }] }.
export default function PolicyPage({ data }) {
  return (
    <>
      <Header />
      <div className="shipping-page policy-page">
        <section className="shipping-hero">
          <h1 className="page-title">
            {data.pageTitle}
            <div className="about-heading-line">
              <img src={DIVIDER} alt="Heading decoration" />
            </div>
          </h1>

          <div className="hero-card">
            <span className="hero-badge">{data.badge}</span>
            <h2>{data.heading}</h2>
            <div className="hero-stars">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
            <p className="hero-description">{data.intro}</p>
            <div className="shipping-points">
              {data.highlights.map((h) => (
                <span key={h}>{h}</span>
              ))}
            </div>
          </div>
        </section>

        <section className="shipping-details">
          {data.sections.map((s, i) => (
            <div className="content-section" key={s.title}>
              <div className="section-heading">
                <h3>
                  <span className="policy-num">{i + 1}.</span> {s.title}
                </h3>
                <div className="heading-line"></div>
              </div>

              {s.paragraphs.map((p, j) => (
                <p key={j}>{p}</p>
              ))}

              {s.bullets && (
                <ul className="policy-list">
                  {s.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              )}

              {(s.after || []).map((p, j) => (
                <p key={`a${j}`}>{p}</p>
              ))}
            </div>
          ))}

          <p className="policy-signoff">
            <strong>AstroLogical Solutions™</strong>
            <br />
            {data.tagline}
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
}
